var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsgMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 217.55,
    y1: -1377.7,
    x2: 217.55,
    y2: -1342.83,
    gradientTransform: "matrix(1 0 0 -1 0 -985.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d8e0eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 435.24,
    y1: -1336.86,
    x2: 435.24,
    y2: -1355.33,
    gradientTransform: "matrix(1 0 0 -1 0 -985.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd3de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 449.25,
    x2: 449.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 463.25,
    x2: 463.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 477.25,
    x2: 477.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 29.93,
    y1: -1331.58,
    x2: 29.93,
    y2: -1352.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 45.97,
    y1: -1331.58,
    x2: 45.97,
    y2: -1352.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 62,
    y1: -1331.58,
    x2: 62,
    y2: -1352.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 78.03,
    y1: -1331.58,
    x2: 78.03,
    y2: -1352.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 341.14,
    y1: -1376.94,
    x2: 418.67,
    y2: -1376.94,
    gradientTransform: "matrix(1 0 0 -1 0 -985.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0bacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969eae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 351.37,
    y1: -1351.17,
    x2: 408.6,
    y2: -1351.17,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 146.07,
    y1: -1212.46,
    x2: 138.4,
    y2: -1212.46,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 149.25,
    y1: -1226.06,
    x2: 135.02,
    y2: -1226.06,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 149.25,
    y1: -1234.58,
    x2: 135.02,
    y2: -1234.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 149.25,
    y1: -1243.1,
    x2: 135.02,
    y2: -1243.1,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 149.25,
    y1: -1251.83,
    x2: 135.02,
    y2: -1251.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 149.25,
    y1: -1260.35,
    x2: 135.02,
    y2: -1260.35,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 149.25,
    y1: -1268.87,
    x2: 135.02,
    y2: -1268.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 147,
    y1: -1277.4,
    x2: 137.66,
    y2: -1277.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 220.4,
    y1: -1290.28,
    x2: 186.26,
    y2: -1290.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 200.27,
    y1: -1298.4,
    x2: 181.73,
    y2: -1298.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 285.54,
    y1: -1290.28,
    x2: 251.4,
    y2: -1290.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 265.42,
    y1: -1298.4,
    x2: 246.88,
    y2: -1298.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 163.88,
    y1: -1357.66,
    x2: 154.68,
    y2: -1357.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 167.16,
    y1: -1371.97,
    x2: 151.3,
    y2: -1371.97,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 314.01,
    y1: -1357.66,
    x2: 304.81,
    y2: -1357.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 317.29,
    y1: -1371.97,
    x2: 301.44,
    y2: -1371.97,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{stroke:#cdd6e1;stroke-linecap:round;stroke-width:3px}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:none}.cls-1,.cls-4,.cls-5{stroke-linejoin:round}.cls-7{fill:#e7ebf2}.cls-8{fill:#e8edf8}.cls-9{fill:#fff}.cls-11{fill:#989fb0}.cls-12{fill:#b9c0d0}.cls-2,.cls-3{stroke-miterlimit:10}.cls-2,.cls-3,.cls-4,.cls-5{stroke-width:2px}.cls-2,.cls-5{stroke:#bbc1cf}.cls-3,.cls-4{stroke:#e7ebf2}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.49 389.01h61.29v4.97H50.49v-4.97ZM54.28 377.86a3.858 3.858 0 0 1 3.66-2.66h46.56c1.67 0 3.14 1.07 3.66 2.66l3.63 11.14H50.66l3.63-11.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.56 177.53v18.77h175.53l-17.01-17.17-158.52-1.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.2 196.3v-17.17l19.57 17.17v-17.17l19.74 17.17v-17.17l19.57 17.17v-17.17M52.58 196.3v-18.45M111.46 179.14v17.17l-19.57-17.17M91.89 179.14v17.17M70.71 367.18h21.02V160.04l-10.59-9.79-10.43 9.79v207.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.73 161.17H70.71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.73 214.11H70.71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.73 231.12H70.71M91.73 247.97H70.71M91.73 264.98H70.71M91.73 281.98H70.71M91.73 298.99H70.71M91.73 315.84H70.71M91.73 332.85H70.71M91.73 349.86H70.71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m174.52 178.98-93.38-28.72L36.7 177.7M91.89 196.3l-21.18-18.13M71.35 196.95l19.9 16.53M71.35 161.49l20.06 16.04M53.22 178.17l16.69 17.81M52.09 195.98l-20.38-17.81M112.1 178.98l18.45 16.53M71.51 214.6l19.74 15.89M71.51 231.76l19.74 15.56M71.35 248.61l19.9 15.72M71.35 265.78l19.9 15.56M71.35 282.63l19.9 15.56M71.35 299.47l19.9 15.72M71.35 316.48l19.9 15.72M71.35 333.49l19.9 15.72M71.35 350.66l19.9 15.56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.08 367.02h40.12c1.42 0 2.56 1.15 2.56 2.56v5.62H58.51v-5.62c0-1.42 1.15-2.56 2.56-2.56ZM114.67 211.87l-12.03 12.03c-.8.8-1.93 1.28-2.89 1.28H69.59v-28.24h46.53v11.87c-.32 1.28-.64 2.25-1.44 3.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87.26 209.77H75.7c-.71 0-1.28-.57-1.28-1.28v-5.62c0-.71.57-1.28 1.28-1.28h11.56c.71 0 1.28.57 1.28 1.28v5.62c0 .71-.57 1.28-1.28 1.28ZM105.51 209.76H93.95c-.71 0-1.28-.57-1.28-1.28v-5.62c0-.71.57-1.28 1.28-1.28h11.56c.71 0 1.28.57 1.28 1.28v5.62c0 .71-.57 1.28-1.28 1.28Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M34.7 343.82h-6.29v51.34h6.29v-51.34ZM79.35 343.82h-6.29v51.34h6.29v-51.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.3 393.33c-17.05.41-37.34 0-51.75-.2-14.41.41-34.7.61-51.75.2 16.84-9.54 22.53-27.19 23.54-38.97h56.21c1.22 11.77 6.9 29.43 23.75 38.97Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M323.28 206.63v145.91c0 3.65-2.84 6.29-6.29 6.29H118.11c-3.45 0-6.29-2.84-6.29-6.29V206.63c0-3.45 2.84-6.29 6.29-6.29h198.88c3.45 0 6.29 2.64 6.29 6.29Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M323.28 206.63v125.82H112.02V206.63c0-3.45 2.84-6.29 6.29-6.29h198.88c3.25 0 6.09 2.64 6.09 6.29Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M315.77 208.05H119.53v117.1h196.04v-117.1h.2Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M217.55 350.71c2.91 0 5.28-2.36 5.28-5.28s-2.36-5.28-5.28-5.28-5.28 2.36-5.28 5.28 2.36 5.28 5.28 5.28ZM439.3 349.5h-5.48v45.05h5.48V349.5ZM478.47 349.5h-5.48v45.05h5.48V349.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M485.37 351.53h-57.63V370h57.63v-18.47Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M441.74 351.53 435.65 370h-6.9l5.89-18.47h7.1Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.74 351.53 449.65 370h-6.9l5.88-18.47h7.1Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.74 351.53 463.65 370h-6.9l5.89-18.47h7.1Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.75 351.53 477.66 370h-6.9l5.88-18.47h7.1Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.26 346.25H21.51v21.11h65.75v-21.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m37.34 346.25-6.9 20.9h-7.91l6.9-20.9h7.91Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.37 346.25-6.9 20.9h-7.91l6.7-20.9h8.12Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.41 346.25-6.9 20.9H54.6l6.7-20.9h8.12Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.44 346.25-6.9 20.9h-7.91l6.7-20.9h8.12Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.32 143.72v24.76"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M243.43 179.23c3.98 0 7.21-3.23 7.21-7.2s-3.23-7.2-7.21-7.2-7.2 3.23-7.2 7.2 3.23 7.2 7.2 7.2Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M236.43 191.2c0 4.46 4.06 8.12 8.93 6.9a7.012 7.012 0 0 0 5.28-5.28c.81-3.86-1.42-7.51-4.87-8.52-1.22-.41-2.03-1.42-2.03-2.84v-6.29"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M418.67 388.46h-77.52v6.29h77.52v-6.29Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.64 373.66a3.858 3.858 0 0 0-3.66-2.66h-60.37c-1.67 0-3.14 1.07-3.66 2.66l-4.82 14.8h77.32l-4.82-14.8Z",
    style: {
      fill: "#cad0dd"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M442.61 120.99v23.74H220.59l21.51-21.71 200.51-2.03Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M316.59 144.73v-21.71l-24.76 21.71v-21.71l-24.96 21.71v-21.71l-24.76 21.71v-21.71M416.03 144.73v-23.34M341.55 123.02v21.71l24.76-21.71M366.31 123.02v21.71M393.09 360.86H366.5V98.87l13.39-12.38 13.19 12.38v262Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.51 100.29h26.59"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M366.51 167.26h26.59"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.51 188.77h26.59M366.51 210.08h26.59M366.51 231.59h26.59M366.51 253.1h26.59M366.51 274.61h26.59M366.51 295.92h26.59M366.51 317.43h26.59M366.51 338.94h26.59"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M261.79 122.81 379.9 86.48l56.21 34.7M366.31 144.73l26.79-22.93M392.28 145.54l-25.16 20.9M392.28 100.69l-25.37 20.29M415.22 121.8l-21.11 22.53M416.64 144.32l25.77-22.53M340.74 122.81l-23.34 20.9M392.08 167.87l-24.96 20.09M392.08 189.58l-24.96 19.69M392.28 210.89l-25.16 19.89M392.28 232.6l-25.16 19.69M392.28 253.91l-25.16 19.68M392.28 275.22l-25.16 19.89M392.28 296.73l-25.16 19.89M392.28 318.24l-25.16 19.89M392.28 339.96l-25.16 19.68"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.95 360.66h-52.1c-1.42 0-2.56 1.15-2.56 2.56v7.79h57.23v-7.79c0-1.42-1.15-2.56-2.56-2.56Z",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M154.84 318.04h-25.16c-2.03 0-3.65-1.62-3.65-3.65v-97c0-2.03 1.62-3.65 3.65-3.65h25.16c2.03 0 3.65 1.62 3.65 3.65v97c0 2.03-1.62 3.65-3.65 3.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.26 233.21c3.36 0 6.09-2.73 6.09-6.09s-2.73-6.09-6.09-6.09-6.09 2.73-6.09 6.09 2.73 6.09 6.09 6.09Z",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.02 242.14h-21.51c-.41 0-.61-.2-.61-.61v-1.62c0-.41.2-.61.61-.61h21.31c.41 0 .61.2.61.61v1.62c.2.41-.2.61-.41.61Z",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.02 250.66h-21.51c-.41 0-.61-.2-.61-.61v-1.62c0-.41.2-.61.61-.61h21.31c.41 0 .61.2.61.61v1.62c.2.41-.2.61-.41.61Z",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.02 259.19h-21.51c-.41 0-.61-.2-.61-.61v-1.62c0-.41.2-.61.61-.61h21.31c.41 0 .61.2.61.61v1.62c.2.41-.2.61-.41.61Z",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.02 267.92h-21.51c-.41 0-.61-.2-.61-.61v-1.62c0-.41.2-.61.61-.61h21.31c.41 0 .61.2.61.61v1.62c.2.2-.2.61-.41.61Z",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.02 276.44h-21.51c-.41 0-.61-.2-.61-.61v-1.62c0-.41.2-.61.61-.61h21.31c.41 0 .61.2.61.61v1.62c.2.2-.2.61-.41.61Z",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.02 284.96h-21.51c-.41 0-.61-.2-.61-.61v-1.62c0-.41.2-.61.61-.61h21.31c.41 0 .61.2.61.61v1.62c.2.41-.2.61-.41.61Z",
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.16 293.49h-13.6c-.41 0-.61-.2-.61-.61v-1.62c0-.41.2-.61.61-.61h13.6c.41 0 .61.2.61.61v1.62c0 .41-.41.61-.61.61Z",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.54 303.43h-54.19v3.04h54.19v-3.04Z",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.78 311.55h-29.43v3.04h29.43v-3.04Z",
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.68 303.43H241.5v3.04h54.18v-3.04Z",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.93 311.55H241.5v3.04h29.43v-3.04Z",
    style: {
      fill: "url(#linear-gradient-23)"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m195.92 204.49 42.96-8.55c3.15-.67 6.3 0 8.77 1.57l33.06 19.12"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m280.25 307.28-108.82-16.42c-3.37-.45-5.62-3.6-5.17-6.97l11.02-78.5c.45-3.37 3.6-5.62 6.97-5.17l108.82 16.42c3.37.45 5.62 3.6 5.17 6.97l-11.02 78.5c-.45 3.15-3.6 5.62-6.97 5.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m276.68 298.35-97.27-15.19c-2.75-.37-4.58-2.93-4.22-5.68l8.98-63.98c.37-2.75 2.93-4.58 5.68-4.22l97.27 15.19c2.75.37 4.58 2.93 4.22 5.68l-8.98 63.98c-.37 2.57-2.93 4.58-5.68 4.22Z",
    style: {
      fill: "#eff3fb"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m337.49 164.42 15.22 15.22c1.01 1.01 2.43 1.62 3.65 1.62h38.15v-35.72h-58.85v15.02c.41 1.62.81 2.84 1.83 3.86Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M371.82 161.76h15.29c.71 0 1.28-.57 1.28-1.28v-7.79c0-.71-.57-1.28-1.28-1.28h-15.29c-.71 0-1.28.57-1.28 1.28v7.79c0 .71.57 1.28 1.28 1.28ZM348.74 161.76h15.29c.71 0 1.28-.57 1.28-1.28v-7.79c0-.71-.57-1.28-1.28-1.28h-15.29c-.71 0-1.28.57-1.28 1.28v7.79c0 .71.57 1.28 1.28 1.28Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 395.16h500"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.89 393.54h-27.4l1.22-3.05 2.84-7.71 2.44-6.7 2.84-7.71 2.03-5.28c.41-1.01 1.42-1.83 2.43-1.83s2.03.61 2.43 1.83l2.03 5.28 2.84 7.71 2.44 6.7 2.84 7.71 1.01 3.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.61 376.08h-14.6l2.75-7.51h9.07l2.78 7.51Z",
    style: {
      fill: "url(#linear-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.87 390.49h-25.16l2.84-7.71h19.48l2.84 7.71Z",
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.89 393.54h-27.6c-.81 0-1.62-.61-1.62-1.62 0-.81.61-1.62 1.62-1.62h27.6c.81 0 1.62.61 1.62 1.62s-.61 1.62-1.62 1.62ZM323.03 393.54h-27.4l1.22-3.05 2.84-7.71 2.43-6.7 2.84-7.71 2.03-5.28c.41-1.01 1.42-1.83 2.44-1.83s2.03.61 2.43 1.83l2.03 5.28 2.84 7.71 2.43 6.7 2.84 7.71 1.02 3.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.75 376.08h-14.6l2.75-7.51h9.07l2.78 7.51Z",
    style: {
      fill: "url(#linear-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.01 390.49h-25.16l2.84-7.71h19.48l2.84 7.71Z",
    style: {
      fill: "url(#linear-gradient-27)"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M323.03 393.54h-27.6c-.81 0-1.62-.61-1.62-1.62 0-.81.61-1.62 1.62-1.62h27.6c.81 0 1.62.61 1.62 1.62s-.61 1.62-1.62 1.62Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M211.57 256.17c2.87.44 5.67-1.62 6.11-4.5.44-2.87-1.63-5.67-4.5-6.11-2.87-.44-5.67 1.63-6.11 4.5-.44 2.87 1.62 5.67 4.5 6.11ZM252.24 262.35c2.87.44 5.67-1.62 6.11-4.5.44-2.87-1.62-5.67-4.5-6.11-2.87-.44-5.67 1.63-6.11 4.5-.47 3.09 1.63 5.67 4.5 6.11ZM214.84 233.29l-12.63 4.53 1.13 3.16 12.63-4.53-1.13-3.16ZM255.01 239.3l-2.02 2.68 10.71 8.07 2.02-2.68-10.71-8.07ZM230.03 271.64c3.42.52 6.5-1.14 6.89-3.7.39-2.56-2.07-5.06-5.48-5.58-3.42-.52-6.5 1.14-6.89 3.7-.39 2.56 2.07 5.06 5.48 5.58Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.28 413.51h269.6M56.59 413.51h34.07"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgMaintenance);
export default __webpack_public_path__ + "static/media/esg_maintenance.f9be66c9e7d26a9fc97d1836c4a3a708.svg";
export { ForwardRef as ReactComponent };